let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ff7Y0")).then(() => parcelRequire('eD5uy'));